import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  standalone: true,
  name: 'timeZoneDate',
})
export class TimeZoneDatePipe implements PipeTransform {
  transform(
    value: Date | string,
    format: string,
    timeZoneOffset: string,
  ): string {
    if (!value) return '';
    return moment(value).utcOffset(timeZoneOffset).format(format);
  }
}
